import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@rq-ratings/pro-regular-svg-icons'
import { useMutation } from '@tanstack/react-query'
import React from 'react'
import { Modal } from 'react-bootstrap'

import { useCreateStateMutation } from '../../../../hooks/useCreateStateMutation'
import { useRefreshSessionMetadataMutation } from '../../../../hooks/useRefreshSessionMetadataMutation'
import { STATE_KEY, STATE_TYPE } from '../../../../lib/constants'
import ActionButton from '../../../misc/ActionButton'
import { useIcaewModals } from '../hooks/useIcaewModals'
import IcaewModalHeader from './IcaewModalHeader'

const IcaewPricingModal: React.FC = () => {
  const createStateMutation = useCreateStateMutation()
  const refreshSessionMetadataMutation = useRefreshSessionMetadataMutation()
  const { recordStepCompletion } = useIcaewModals()

  const recordInteractionMutation = useMutation({
    mutationFn: () =>
      createStateMutation.mutateAsync({
        stateKey: STATE_KEY.hasInteractedWithIcaewPricingModal,
        stateValue: true,
        stateType: STATE_TYPE.companyUser,
      }),
    onSuccess: async () => {
      await refreshSessionMetadataMutation.mutateAsync()
      recordStepCompletion()
    },
  })

  function handleHide() {
    recordInteractionMutation.mutate()
  }

  const isHiding = recordInteractionMutation.isPending

  return (
    <Modal show onHide={handleHide}>
      <IcaewModalHeader>Discounted pricing for ICAEW firms</IcaewModalHeader>

      <Modal.Body>
        <p className="text-lg">
          Good news! Because you're an ICAEW-regulated firm, you can use RQ for
          free.
        </p>

        <div
          className="mb-3 text-decoration-line-through"
          style={{ fontSize: '18px' }}
        >
          Standard price: Starting at £199/month.
        </div>

        <div className="text-black" style={{ fontSize: '24px' }}>
          ICAEW-regulated firms: <span className="text-success">£0/month</span>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <ActionButton
          variant="primary"
          isProcessing={isHiding}
          showIsProcessingText={false}
          className="d-flex align-items-center gap-2"
          onClick={handleHide}
          size="lg"
        >
          Continue
          <FontAwesomeIcon icon={faArrowRight} />
        </ActionButton>
      </Modal.Footer>
    </Modal>
  )
}

export default IcaewPricingModal
